import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineLink } from '../../base/outline-link/outline-link';
import { ifDefined } from 'lit/directives/if-defined.js';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-full-width-button.css.lit';
import '../../base/outline-icon/outline-icon';

export const SEFullWitdhButtonDirections = ['right', 'left'];
export type SEFullWitdhButtonDirection =
  typeof SEFullWitdhButtonDirections[number];

/**
 * The SeFullWitdhButton component
 * @element se-full-width-button
 */
@customElement('se-full-width-button')
export class SeFullWitdhButton extends OutlineLink {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  label: string;

  @property({ type: String })
  direction: SEFullWitdhButtonDirection = 'right';

  iconTemplate() {
    return html`<outline-icon
      color="brand-primary-2"
      library="system"
      name="${this.direction === 'left' ? 'arrow-left' : 'arrow-right'}"
      size="1.125rem"
    >
    </outline-icon> `;
  }

  render(): TemplateResult {
    const wrapperClasses = {
      'se-full-width-button': true,
      'se-full-width-button--left': this.direction == 'left',
    };
    return html`<a
      class="${classMap(wrapperClasses)}"
      href=${this.linkHref}
      rel="${ifDefined(this.linkRel)}"
      target="${ifDefined(this.linkTarget)}"
      aria-label="${ifDefined(this.label)}"
    >
      <span class="se-full-width-button__label">
        ${this.direction === 'left' ? this.iconTemplate() : null}
        ${this.linkText ? html`${this.linkText}` : html`<slot></slot>`}
        ${this.direction !== 'left' ? this.iconTemplate() : null}
      </span>
    </a>`;
  }
}
